export enum WebinarTemplateType {
  DEFAULT = 'DEFAULT',
}
